const REG_EX_TOKEN = RegExp('^[2345679ACDEFGHJKLMNPQRSTUVWXYZ]{5,8}$');

export function validateToken(token: string) {
  return REG_EX_TOKEN.test(token);
}

export function getCertificateProgramTypeFromSemanticType(semanticType: string) {
  if (semanticType === 'Degree') {
    return 'Nanodegree';
  }
  if (semanticType === 'Part') {
    return 'Course';
  }
}

export const certificatePrintStyles = {
  '@media print': {
    '@page': {
      size: 'landscape',
      margin: '0 !important',
      padding: '0 !important',
    },
    'header, footer, aside, form': {
      display: 'none !important',
    },
    '#certificate-container': {
      height: '8.5in !important',
      width: '11in !important',
      colorAdjust: 'exact !important',
    },
    '#certificate-wrapper': {
      position: 'absolute',
      maxWidth: 'unset',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
    '#certificate': {
      width: '100% !important',
      height: '100% !important',
    },
    '#certificate-inner': {
      justifyContent: 'space-between',
      p: '40px',
      height: '100% !important',
      maxHeight: '100% !important',
    },
    '#certificate-inner svg': {
      position: 'fixed',
      top: 0,
      marginTop: -10,
    },
    '#certificate-footer': {
      flexDirection: 'row !important',
      alignItems: 'end',
    },
    '#signature-wrapper': {
      flexDirection: 'row',
    },
    '#thrun-sig, #sponsor-sig': {
      width: '225px',
    },
    '#confirm-link': {
      order: '0',
      alignSelf: 'end',
    },
    '#udacity-logo-container': {
      mb: 1,
    },
    '#udacity-logo-container, #company-logo-container, #initiative-logo-container': {
      gap: 8,
    },
    '#company-logo-container': {
      marginEnd: 4,
    },
    '#certificate-message, #certificate-buttons, #browse-catalog-link, #view-details-link': {
      display: 'none',
    },
  },
};
